/* eslint-disable dot-notation */
/* eslint-disable react/require-default-props */
import React from "react";
import styles from "./wellsFargoModal.module.scss";

export interface ModalProps {
  title?: string;
  subTitle1?: string;
  subTitle2?: string;
  continueText: string;
  cancelText?: string;
  onContinue: () => void;
  onCancel?: () => void;
  modalClassName?: string;
}

const WellsFargoModal: React.FC<ModalProps> = (props): JSX.Element | null => {
  const {
    title,
    subTitle1,
    subTitle2,
    continueText,
    cancelText,
    onContinue,
    onCancel,
    modalClassName,
  } = props;

  return (
    <div className={styles["wellsfargo-modal"]}>
      <div
        className={`c-modal ${styles["ProjectShiftModal"]} ${modalClassName}`}
        data-testid="wf-modal"
        aria-hidden="false"
        id="wf-modal"
      >
        <div className="c-modal__overlay " tabIndex={-1} />
        <div
          className={styles["c-modal__wrapper"]}
          role="dialog"
          aria-labelledby="foo-bar-baz"
        >
          <header className={styles["c-modal__header"]}>
            <div className="c-modal__title__wrapper">
              <h2 className={styles["c-modal__title"]} id="foo-bar-baz">
                {title}
              </h2>
            </div>
          </header>
          <div className={styles["c-modal__content"]} role="document">
            <p className={styles["text-modal"]}>{subTitle1}</p>
            <p className={styles["text-modal"]}>{subTitle2}</p>
          </div>
          <div className={styles["c-modal__footer"]}>
            <div className={styles["c-modal__actions"]}>
              {/* eslint-disable-next-line dot-notation */}
              <div className={`c-modal__actions__item ${styles["flexItem"]}`}>
                <button
                  type="button"
                  className={`c-btn  c-btn--secondary ${styles["buttonWidth"]}`}
                  data-testid="cancelBtn"
                  onClick={onCancel}
                  aria-label="Close this dialog window."
                >
                  <span className="c-btn__text">{cancelText}</span>
                </button>
              </div>
              <div className={`c-modal__actions__item ${styles["flexItem"]}`}>
                <button
                  type="button"
                  className={`c-btn ${styles["buttonWidth"]}`}
                  data-testid="continueBtn"
                  aria-label="Open wells Fargo link"
                  onClick={onContinue}
                >
                  <span className="c-btn__text">{continueText}</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WellsFargoModal;
